module.exports = __webpack_public_path__ + "static/media/notebook.6cfd5789.png";